import { Link } from "react-router-dom"
import "./PharmacyFirstPage.css"

const conditions = [
  { name: "Otitis Media (Ear Infection)", description: "Pain or discomfort in the ear. Age: 1-17 years" },
  { name: "Impetigo", description: "Skin rash and infection. Age: 1+ years" },
  { name: "Sore Throat", description: "Pain or irritation in the throat. Age: 5+ years" },
  { name: "Infected Insect Bite", description: "Bites showing signs of infection. Age: 1+ years" },
  { name: "Shingles", description: "Painful rash caused by the varicella-zoster virus. Age: 18+ years" },
  { name: "Urinary Tract Infection (UTI)", description: "Infections affecting the urinary system. Women aged 16-64 years" },
  { name: "Sinusitis", description: "Inflammation of the sinuses. Age: 12+ years" },
]

const faqs = [
  {
    question: "How can Pharmacy First save time?",
    answer: "Pharmacy First will help you get seen by a healthcare professional quickly. Instead of waiting for a GP appointment, going to A&E or attending out-of-hours NHS services, you can walk into your nearest Pharmacy and have a private consultation with one of our pharmacists whenever you need to."
  },
  {
    question: "What are the benefits of Pharmacy First?",
    answer: "Pharmacy First will allow you to self-treat minor ailments and reduce the time you spend at your GP surgery. Pharmacists have a range of clinical skills, and they will be able to provide accurate clinical advice without the hassle and waiting times that you might experience using other NHS services like A&E. If it turns out you need treatment from a GP, your pharmacist can also refer you to them."
  },
  {
    question: "Who is eligible for Pharmacy First?",
    answer: "Only patients in England will be eligible for the Pharmacy First service."
  },
  {
    question: "Will I need to prove that I don't have to pay for my prescriptions?",
    answer: "If you are exempt from paying for prescriptions, you should show your pharmacists evidence of this when you speak to them. They will need it if they recommend any medicines to treat your symptoms."
  },
  {
    question: "What will the pharmacist ask during my consultation?",
    answer: "Our pharmacist will want to understand the symptoms you're experiencing, your medical history, and if you're experiencing any other types of illness. This will help them recommend treatments and medicines that will work for you."
  },
]

function PharmacyFirstPage() {
  return (
    <div className="pharmacy-first-page">
      <section className="pf-hero">
        <h1>Pharmacy First</h1>
        <p className="pf-tagline">
          Get prescriptions and health advice from your local pharmacist
        </p>
      </section>

      <section className="pf-intro">
        <p>
          Book an appointment or contact your local pharmacy if you are experiencing any signs or
          symptoms relating to any of these common conditions. Stay well and avoid long waits at
          your GP or in A&E.
        </p>
        <p>
          Pharmacy First allows you and your loved ones to get health advice from our expert
          pharmacists. They can then provide NHS treatments for a range of common conditions.
        </p>
        <p className="pf-highlight">
          We can provide you the same treatments you would get from a GP.
        </p>
      </section>

      <section className="pf-conditions">
        <h2>Conditions We Can Treat</h2>
        <div className="conditions-grid">
          {conditions.map((condition, index) => (
            <div key={index} className="condition-card">
              <div className="condition-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
                </svg>
              </div>
              <h3>{condition.name}</h3>
              <p>{condition.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="pf-cta">
        <h2>Ready to Get Started?</h2>
        <p>
          The Pharmacy First service is an accessible service for all, where you can receive
          support, advice and if necessary, medication to support you with common conditions.
        </p>
        <Link to="/services?service=pharmacy-first" className="button primary">
          Book a Consultation
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 18l6-6-6-6" />
          </svg>
        </Link>
      </section>

      <section className="pf-faq">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <h3>{faq.question}</h3>
              <p>{faq.answer}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}

export default PharmacyFirstPage
